import styles from "./UserTimeTracking.module.css";
import Helmet from "react-helmet";
import Footer from "../../components/Footer";
import TimeTracking from "./components/TimeTracking";
import Loader from "../../components/Loader";
import withCustomAuthenticationRequired from "../../auth/withCustomAuthenticationRequired";

function UserTimeTracking() {

  return (<>
    <Helmet title="Time Tracker" />

    <div className={`${styles.mainCard}`}>
      <div className={`${styles.CenterBlockSec}`}>
        <TimeTracking />
      </div>
    </div>

    <Footer />
  </>);
}

export default withCustomAuthenticationRequired(UserTimeTracking, {
  onRedirecting: () => <Loader />,
});